<template>
    <div class="container">
        <div class="logo">
            <img src="../assets/img/template@2x(1).png" style="width: 170px;height: 70px;"/>
        </div>
        <!-- 菜单栏 -->
        <div class="menuBox">
            <div class="twoLevel">
                <el-aside>
                    <el-menu v-if="role === '个人'" router  @open="handleOpen" @close="handleClose"  class="el-menu-vertical-demo" background-color="rgba(220,38,38,0.0)"  active-text-color="#7886CA" :unique-opened="true"  :default-active="currentMenu">
                    <el-menu-item index="/home"  @click="goRouter()" style="display:flex;align-items: center;">
                        <template slot="title"><i class="el-icon-house"></i>首页</template>
                    </el-menu-item>
                    <el-menu-item index="/user"  @click="goRouter()" style="display:flex;align-items: center;">
                        <template slot="title"><i class="el-icon-folder"></i>文件管理</template>
                    </el-menu-item>
                    <el-menu-item index="/guide"  @click="goRouter()" style="display:flex;align-items: center;">
                      <template slot="title"><i class="el-icon-discover"></i>用户指南</template>
                    </el-menu-item>
                </el-menu>
                <el-menu v-if="role === '机构'" router  @open="handleOpen" @close="handleClose"  class="el-menu-vertical-demo" background-color="rgba(220,38,38,0.0)"  active-text-color="#7886CA" :unique-opened="true"  :default-active="currentMenu">
                    <el-menu-item index="/org"  @click="goRouter()" style="display:flex;align-items: center;">
                        <template slot="title"><i class="el-icon-house"></i>首页</template>
                    </el-menu-item>
                    <el-menu-item index="/orgGuide"  @click="goRouter()" style="display:flex;align-items: center;">
                      <template slot="title"><i class="el-icon-discover"></i>用户指南</template>
                    </el-menu-item>
                </el-menu>
                </el-aside>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "CrmMisComsidemenu",
    
    components: {
    
    },

    data() {
        return {
            menuData: [], // 一级菜单数据
            twoMenuData: [], // 二级菜单数据
            oneSelected: 0, // 一级选中
            sonSelected: 0, // 子级选中
            activeNames: ['1'],
            currentMenu:null,
            role:localStorage.getItem("role")
        };
    },
    created(){
        // this.getMenu()
        this.getCurrentMenu(this.$route.path)
    },
    mounted() {
        // 页面进入时加载内容
    },
    watch:{
        //监听当前激活的path
        $route(to,from){
             this.getCurrentMenu(to.path)
        } 
    },
    methods: {
        getCurrentMenu (path) {
            this.currentMenu = path
            
	    },
        // 展开
        handleOpen(key, keyPath) {
        },
        // 关闭
        handleClose(key, keyPath) {
        },
        
        // 获取菜单数据
        getMenu(){
            
            // this.$api.user.dynamicMenu()
            // .then(res => {
            //     this.menuData = res.data.menu
            //     let authority = res.data.route
            //     window.sessionStorage.setItem('authority', authority);
            // })
        },
         // 加载二级菜单数据
        loadTwoLevel(index){
            // this.oneSelected = index
            // this.twoMenuData = this.menuData[index].children
            // this.$router.push(this.menuData[index].content)
        },
        // 加载三级菜单
        loadThreeLevel(index){
            // this.sonSelected = index
        },
        handleChange(val) {
            
        },
        // 跳转页面
        goRouter(){
            // localStorage.setItem('routername',"首页")
            // this.resetSetItem('routerlist', "首页");
            // this.$router.push('/')
            
        }
    },
};
</script>
<style lang="scss" scoped>
.el-menu-item.is-active {
    color: rgb(146, 80, 230) !important;
    background-color: rgb(235, 221, 254) !important;
    border-left: 5px solid rgb(146, 80, 230) !important;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
width: 210px;
}
.active{
background: #7886CA;
color: white;
}
.logo{
    border-bottom: 1px solid #eee;
    height: 70px;
    img{
        width: 150px;
        height: 80px;
    } 
}
ul{
    list-style-type: none;
    margin: 0;
    padding: 0;
}
.container{
    // background:linear-gradient(to top,#AFD8F8,#7886CA);
    background-color: white;
    .indexBar{
        height: 8%;
        padding: 5px;
    }
    .menuBox{
        height: 95%;
        color: #fff;
        display: flex;
        .oneLevel{
            width: 100%;
            margin-top: 20px;
            ul{       
                li{
                    :hover{
                        background: #eee;
                        color: #7886CA;
                    }
                    
                    div{
                        cursor: pointer;
                         // background-color: #272E38;
                        text-align: center;
                        margin-top: 10px !important;
                        padding: 10px 0;
                    }
                    img{
                        width: 18px;
                        height: auto;
                        margin-bottom: 5px !important;
                    }
                    span{
                        display: block;
                        font-size: 16px;

                    }
                }

            }   
        }
        .twoLevel{
            width: 100%;
            ul{
                li{
                    // background-color: #272E38;
                    text-align: center;
                    margin-top: 10px !important;
                    padding: 10px 0;
                    div{
                        cursor: pointer;
                         // background-color: #272E38;
                        text-align: center;
                        margin-top: 10px !important;
                        padding: 10px 0;
                    }
                    img{
                        width: 18px;
                        height: auto;
                        margin-bottom: 5px !important;
                    }
                    span{
                        display: block;
                        font-size: 12px;

                    }
                }

            }  
        }

    }
}
</style>